import React, { useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import {
  faGithub,
  faInstagram,
  faLinkedin
} from "@fortawesome/free-brands-svg-icons"
import {HamburgerIcon} from '@chakra-ui/icons'
import { Box, VStack, HStack, MenuDivider, Hide, Flex, Spacer, Menu, MenuItem, MenuButton, Show, MenuList, IconButton} from "@chakra-ui/react";

const socials = [
  {
    icon: faEnvelope,
    url: "mailto: ryesawit132@gmail.com",
  },
  {
    icon: faGithub,
    url: "https://github.com/RaiSaw",
  },
  {
    icon: faLinkedin,
    url: "https://www.linkedin.com/in/raisawit",
  },
  {
    icon: faInstagram,
    url: "https://instagram.com/rai_ku_",
  },
]

const Header = () => {
  const headerRef = useRef(null);

  useEffect(() =>{
    let prevScrollPos = window.scrollY

    const handleScroll = () => {
      const currentScrollPos = window.scrollY
      const headerElement = headerRef.current
      if (!headerElement){
        return
      }
      if (prevScrollPos > currentScrollPos){
        headerElement.style.transform = 'translateY(0)'
      }else{
        headerElement.style.transform = 'translateY(-200px)'
      }
      prevScrollPos = currentScrollPos
    }
    window.addEventListener('scroll', handleScroll)
      return () =>{
          window.removeEventListener('scroll', handleScroll)
      }
  }, [])
  const handleClick = (anchor) => () => {
    const id = `${anchor}-section`;
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
     <Box
      ref={headerRef}
      position="fixed"
      top={0}
      left={0}
      right={0}
      translateY={0}
      transitionProperty="transform"
      transitionDuration="0.3s"
      transitionTimingFunction="ease-in-out"
      bg="#18181b"
    >
        <Flex
          px={8}
          py={4}
          gap={6}
          justifyContent="space-between"
          alignItems="center"
          color="white"
          margin="0 auto"
          maxWidth="1280px"
        >
          <Hide below='sm'>
          <nav>
            <HStack gap={6}>
              {socials.map((social) =>(
                <a key={social.url} href={social.url} rel='navicons'>
                  <FontAwesomeIcon icon={social.icon} size="2x"/>
                </a>
              ))}
            </HStack>
          </nav>
          <Spacer/>
          <nav>
            <HStack gap={6}>
            <a href='/#projects' onClick={handleClick('projects')}>Projects</a>
            <a href='/#contact-me' onClick={handleClick('contactme')}>Contact Me</a>
            </HStack>
          </nav>
          </Hide>
            <Show below='sm'>
            <Menu aria-label='menu' isLazy>
            {({ isOpen }) => (
              <>
                <MenuButton
                  as={IconButton}
                  aria-label='Menu'
                  variant='subtle'
                  icon={<HamburgerIcon/>}
                  _expanded={{ bg:'#18181b', color:'teal.500' }}
                  isActive={isOpen}
                  size='sm'
                >
                {isOpen ? 'Close' : 'Open'}
                </MenuButton>
                <MenuList p={3} bg='#18181b' color='teal.500' _focus={{ boxShadow: 'outline' }}>
                <VStack alignItems='flex-start'>
                <a href='/#top' onClick={handleClick('top')}>Home</a>
                <a href='/#projects' onClick={handleClick('projects')}>Projects</a>
                <a href='/#contact-me' onClick={handleClick('contactme')}>Contact Me</a>
                </VStack>
                <MenuDivider/>
                <MenuItem as='a' gap={4}>
                  {socials.map((social) =>(
                <a key={social.url} href={social.url} rel='navicons'>
                  <FontAwesomeIcon icon={social.icon} size="2x"/>
                </a>
              ))}</MenuItem>
                </MenuList>
                </>
            )}
              </Menu>
              </Show>
        </Flex>
      </Box>
  );
};
export default Header;
